<div>
    <input class="form-check-input" type="checkbox" [checked]="model == trueValue" (change)="changeCheckboxValue($event)" [id]="id">
    <label *ngIf="label && label!=''" class="form-check-label" [for]="id">{{label}}</label>
</div>